









































import {Component, Prop, Watch} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
@Component
export default class Patient extends AbpBase {
	@Prop() patient :any
	data:any = this.patient
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/basic.vue